import { __rest } from "tslib";
import React, { useMemo } from 'react';
import cn from 'classnames';
import PassengersDetails from '../PassengersDetails/PassengersDetails';
import { useIsMobile } from '../../../utils';
import { MobileDialog } from '@shared/ui';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import { useChangeLink } from '../../hooks';
import { BaseButton, ModalX } from '../../../BaseComponents';
import ModalConfirm from '../../../ModalConfirm';
const errorLocale = `Could not be change the 'LinkedTo' link for traveler`;
const PassengersDetailsModal = (_a) => {
    var { isOpen, onClose, orderId } = _a, props = __rest(_a, ["isOpen", "onClose", "orderId"]);
    const { t } = useTranslation('OrderCard');
    const { PassengersDetailsModal: css } = useTheme('PassengersDetails');
    const isMobile = useIsMobile();
    const changeLink = useChangeLink(orderId);
    const { confirmRelinking, isLoading, isRelinkingMode, error, clearError, onCloseRelinkMode } = changeLink;
    const title = isRelinkingMode ? t('Select an adult for accompany') : t('Passengers details');
    const errorKey = useMemo(() => {
        if (error === null || error === void 0 ? void 0 : error.includes(errorLocale)) {
            return errorLocale;
        }
        return error;
    }, [error]);
    const handleCloseModal = () => {
        if (isLoading) {
            return;
        }
        onClose();
        setTimeout(() => {
            onCloseRelinkMode();
        }, 100);
    };
    const confirmButton = (React.createElement(BaseButton, { className: css.confirm__button, variant: "smallThird", isLoading: isLoading, onClick: confirmRelinking }, t('Confirm')));
    const mobileDialogFooter = React.createElement("div", { className: css.mobileDialog__footer }, confirmButton);
    const modalXFooter = (React.createElement("div", { className: css.modalX__footer },
        React.createElement(BaseButton, { variant: "smallSecondary", disabled: isLoading, onClick: onCloseRelinkMode }, t('Cancel')),
        confirmButton));
    return (React.createElement(React.Fragment, null,
        isMobile ? (React.createElement(MobileDialog, { classes: {
                root: cn(css.mobileDialog__root, { [css.mobileDialog__relink]: isRelinkingMode }),
                paper: css.mobileDialog__paper,
                mobileDialog__header: css.mobileDialog__header,
                mobileDialog__title: css.mobileDialog__title
            }, title: title, isOpen: isOpen, onClose: handleCloseModal, onGoBackward: isRelinkingMode ? onCloseRelinkMode : undefined, footer: isRelinkingMode ? mobileDialogFooter : undefined },
            React.createElement("div", { className: css.mobileDialog__content },
                React.createElement(PassengersDetails, Object.assign({}, props, changeLink))))) : (React.createElement(ModalX, { classes: { paper: css.modalX__paper, top_wrapper: css.modalX__top_wrapper }, title: React.createElement("div", { className: css.modalX__title }, title), size: 'large', isOpen: isOpen, onClose: handleCloseModal, keepMounted: false, footer: isRelinkingMode ? modalXFooter : undefined },
            React.createElement(PassengersDetails, Object.assign({}, props, changeLink)))),
        React.createElement(ModalConfirm, { isOpen: !!error, title: t('Oops...'), onClose: clearError, confirmBtn: t('OK'), onConfirm: clearError },
            React.createElement("div", { className: css.modalConfirm__content },
                React.createElement("span", null, t('An error occurred while executing the request. Please try again later or contact a customer support service.')),
                React.createElement("span", { className: css.modalConfirm__error }, t(errorKey))))));
};
export default PassengersDetailsModal;
